import React from 'react';
import type { TimeHourGridProps } from './types';
import TimeCell from './TimeCell';
import { TimeGrid } from './styles';

const TimeHourGrid = ({ hours, selectedMinutes, onSelectHour }: TimeHourGridProps) => (
  <TimeGrid>
    {hours.map(({ hour, error }) => {
      const isSelected = !error && selectedMinutes != null && selectedMinutes === hour.minutes;

      return (
        <TimeCell
          key={hour.formattedTime}
          isSelected={isSelected}
          disabled={error}
          error={error}
          onClick={() => onSelectHour(hour, error)}
        >
          {hour.formattedTime}
        </TimeCell>
      );
    })}
  </TimeGrid>
);

export default TimeHourGrid;
